var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritesMenuSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63707 4.33767L10.0435 4.71185L10.4499 4.33767C11.1842 3.66156 12.6117 2.6 14.2422 2.6C16.5667 2.6 18.487 4.55044 18.487 6.98318C18.487 7.67747 18.1733 8.38341 17.8083 8.95886C17.4498 9.52394 17.0836 9.89809 17.0659 9.91615L17.0638 9.91829L10.0435 17.1393L3.01927 9.9143L3.01927 9.91429L3.01705 9.91203C3.00155 9.89626 2.63627 9.52311 2.27824 8.95846C1.91365 8.38347 1.6 7.67751 1.6 6.98318C1.6 4.55044 3.52022 2.6 5.84472 2.6C7.47522 2.6 8.90275 3.66156 9.63707 4.33767Z",
    stroke: "#E0D2C1",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesMenuSvg);
export default __webpack_public_path__ + "static/media/FavoritesMenuSVG.07fdb86ecb4471a1d355f099e345229c.svg";
export { ForwardRef as ReactComponent };